import { Social } from "./types.js";
import { SPRest } from "../rest.js";
export { MySocial, Social, SocialActorType, SocialActorTypes, SocialFollowResult, SocialStatusCode, } from "./types.js";
Reflect.defineProperty(SPRest.prototype, "social", {
    configurable: true,
    enumerable: true,
    get: function () {
        return this.childConfigHook(function (_a) {
            var options = _a.options, baseUrl = _a.baseUrl, runtime = _a.runtime;
            return Social(baseUrl).configure(options).setRuntime(runtime);
        });
    },
});
//# sourceMappingURL=index.js.map